import { createContext, useContext, useMemo } from "react";
import { Navigate } from "react-router-dom";
import { getStoredToken, getStoredUser } from "../auth/authStorage";
import { canAccessAdminDashboard, isHospitalAdmin, isDoctorAdmin, isSuperUser } from "../auth/rbac";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const user = getStoredUser();
  const token = getStoredToken();

  const value = useMemo(
    () => ({
      user,
      token,
      isAuthenticated: Boolean(token && user),
      isSuperUser: isSuperUser(user),
      isHospitalAdmin: isHospitalAdmin(user),
      isDoctorAdmin: isDoctorAdmin(user),
    }),
    [user, token]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return ctx;
};

export const RequireAdminAuth = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  if (!isAuthenticated || !canAccessAdminDashboard(user)) {
    return <Navigate to="/login" replace />;
  }
  return children;
};
